import AuthenticationService from "../services/authentication-service";
import RequestHelper from "../helpers/requestHelper";
import { STORE_AUTHENTICATION, CLEAR_AUTHENTICATION } from "../constants/actionCreators";

export const logoutGovBr = (config) => _ => {
    const hostGovBr = config.urlSso.substring(0, config.urlSso.indexOf("/au"))
    const redirect_uri = config.redirectUri.substring(0, config.redirectUri.indexOf("/au"))

    const url = `${hostGovBr}/logout?post_logout_redirect_uri=${redirect_uri}`;
    const externalWindow = window.open(
        url,
        "janela",
        "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=300,height=600"
    );
    if (externalWindow) {
        setTimeout(() => {
            externalWindow.close();
        }, 5000);
    }
    localStorage.setItem("omni_ifs_auth", "logged_out");
    localStorage.removeItem("omni_ifs_ts");
    localStorage.removeItem("user_session");
};

export const sendAuthentication = (code, state) => _ => {
    const promise = new AuthenticationService().send(code, state)
    promise
        .then(res => {
            window.close()
        })
        .catch(err => {
            console.error(err);
            window.close()
        })
};

export const getUser = (state) => dispatch => {
    const promise = new AuthenticationService().getData(state)
    promise
        .then(RequestHelper.handleResponse)
        .then(res => {
            localStorage.setItem('user_session', JSON.stringify({ ...res }))
            dispatch(storeAuthencation({
                ...res,
                state
            }))
            return Promise.resolve(res)
        })
        .catch(err => {
            if (err.response) {
                console.log(err.response.data);
                dispatch(storeAuthencation(err.response.data))
            } else {
                dispatch(storeAuthencation({
                    message: "Não foi possível realizar a autenticação com sucesso \nRequest failed with status code 400",
                    type: "error"
                }))
            }
            return Promise.reject(err)
        })
    return promise
};



export const storeAuthencation = (user) => ({
    type: STORE_AUTHENTICATION,
    user
});

export const clearUser = () => ({
    type: CLEAR_AUTHENTICATION
});
